import { useEffect } from 'react'
import { useNavigate } from "react-router-dom"

import Container from '../../components/Container'
import Background from '../../components/Background'
import Form from '../../components/Form'

import Investors from '../../components/Investors'
import BestInClass from '../../components/BestInClass'
import Pilot from '../../components/Pilot'
import ValuePropositions from '../../components/ValuePropositions'
import PerformanceSecuritySafety from '../../components/PerformanceSecuritySafety'

import { mixpanel_client_track } from '../../libs/mixpanelClient'

const DemoPage = ({
  coordinator,
  set_coordinator,
  user_data,
  set_user_data,
  demo_is_active,
  set_demo_is_active,
  set_demo_modal_is_open,
  journey,
}: {
  coordinator: any
  set_coordinator: any
  user_data: any
  set_user_data: any
  demo_is_active: any
  set_demo_is_active: any
  set_demo_modal_is_open: any
  journey: any
}) => {
  const navigate = useNavigate()

  useEffect(() => {
    mixpanel_client_track('www_demo_visited', null)
  }, [])

  return (
    <div id="top" className="">
      {/* Hero section */}
      <div className="relative isolate overflow-hidden">
        {/* Background with graph/orb/cards anchored to right side */}
        <div className="absolute inset-0 overflow-hidden">
          <Background className="" leftFadeOffsetPx={-20} blurBelowLg />
        </div>

        {/* Left column: form */}
        <Container className="relative flex flex-col items-start justify-center min-h-[calc(100vh-8px)] py-24 md:py-0 z-10 pointer-events-none">
          <div id="hero-content" className="flex w-full max-w-3xl pointer-events-auto mt-12 lg:mt-24">
            <div className="w-full max-w-xl">
              <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-light tracking-tight text-white drop-shadow-lg mb-8">
                Book a demo
              </h1>
              <Form user_data={user_data} set_user_data={set_user_data} />
            </div>
          </div>
        </Container>
      </div>

      {/* Post-hero sections (same as root page) */}
      <Investors />
      <BestInClass />
      <Pilot />
      <ValuePropositions />
      <PerformanceSecuritySafety />
    </div>
  )
}

export default DemoPage